import {
	CvMidTermAdjustmentClient as CvMidTermAdjustmentClientV2,
	PcMidTermAdjustmentClient as PcMidTermAdjustmentClientV2,
	RateCvMidTermAdjustmentByPolicyTokenCommand,
	RatePcMidTermAdjustmentByPolicyTokenCommand,
} from '../../services/mtaApiV2';
import { MidTermAdjustmentRatingResponse } from '../../services/api';
import API from '../../services/AxiosInstance';
import { Product } from '../../services/interface/Shared';

function isRateCvMidTermAdjustmentCommand(
	command: RateCvMidTermAdjustmentByPolicyTokenCommand | RatePcMidTermAdjustmentByPolicyTokenCommand,
): command is RateCvMidTermAdjustmentByPolicyTokenCommand {
	if (typeof command !== 'object' || command === null) {
		return false;
	}

	if (!('midTermAdjustment' in command) || !command.midTermAdjustment) {
		return false;
	}

	const { midTermAdjustment } = command;

	if (!('vehicleDetails' in midTermAdjustment) || !midTermAdjustment.vehicleDetails) {
		return false;
	}

	const { vehicleDetails } = midTermAdjustment;

	const requiredCvFields = [
		'businessRadius',
		'hasInternalRacking',
		'vehicleCarriesDangerousGoods',
		'vehicleVisitsHazardousSites',
	] as const;

	return requiredCvFields.every((field) => field in vehicleDetails);
}

const mtaHandleRating = async (
	product: Product,
	command: RateCvMidTermAdjustmentByPolicyTokenCommand | RatePcMidTermAdjustmentByPolicyTokenCommand,
) => {
	let result: MidTermAdjustmentRatingResponse;
	try {
		if (
			(product === Product.COMMERCIAL_VEHICLE || product === Product.TAXI) &&
			isRateCvMidTermAdjustmentCommand(command)
		) {
			const client = new CvMidTermAdjustmentClientV2(undefined, API);
			result = await client.rateCvMidTermAdjustment(command);
		} else if (product !== Product.COMMERCIAL_VEHICLE && product !== Product.TAXI) {
			const client = new PcMidTermAdjustmentClientV2(undefined, API);
			result = await client.ratePcMidTermAdjustment(command as RatePcMidTermAdjustmentByPolicyTokenCommand);
		} else {
			throw new Error('Invalid command type for product');
		}
		return result;
	} catch (error) {
		console.error('Error during MidTermAdjustmentRatingResponse rating:', error);
		throw error;
	}
};

export default mtaHandleRating;
